import { render } from "./Staff.vue?vue&type=template&id=7a44a1a4"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=7a44a1a4&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__